<template>
  <van-popup v-model="visible" position="bottom" closeable round>
    <div class="popup-title">客户信息授权声明</div>
    <div class="content" ref="content">
      <p>
        <span>我们需要收集您的人脸信息，并将您的姓名、身份证号传输至与我们合作的可信机构进行身份验证。点击</span>
        <span class="blue" @click="jumpTBxieyi">《新华人寿保险股份有限公司个人信息保护政策》</span>
        <a href="/m/tbAgreement.html"></a>
        <span>查阅可信机构具体情况。我们强烈建议您在进行用户认证之前仔细阅读合作方的个人信息保护政策。如果您不同意进行上述用户认证，您将无法使用本服务。</span>
      </p>
    </div>
    <div class="btn" :class="{'gray': !isLook}" @click="ok">知悉并同意以上内容</div>
  </van-popup>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      isLook: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    open() {
      this.visible = true;
      this.isLook = false;
      setTimeout(()=>{
        const a = this.$refs.content;
        a.onscroll = this.checkLook;
        this.checkLook();
      }, 1000);
    },
    jumpTBxieyi(){
      sessionStorage.setItem("jumpTBxieyi", "1");
      location.href = "/m/tbAgreement.html";
    },
    // 检测是否阅读完毕
    checkLook() {
      const a = this.$refs.content;
      if (a.scrollTop + a.clientHeight >= a.scrollHeight - 30) {
        this.isLook = true;
      }
    },
    ok(){
      if(!this.isLook) {
        this.$notice.msg("请先阅读完客户信息授权声明");
        return;
      }
      this.visible = false;
      this.$emit("ok");
    }
  }
};
</script>
<style lang="scss" scoped>
.popup-title {
  height: 100px;
  line-height: 100px;
  text-align: center;
  border-bottom: 1px solid #E7EAEC;
  font-size: 30px;
}
.content {
  width: 100%;
  max-height: 60vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 40px;
  * {
    max-width: 100%;
  }
  h3 {
    font-size: 28px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 1em;
  }
  p {
    font-size: 26px;
    margin-bottom: 1em;
  }
}
.btn {
  width: 690px;
  height: 90px;
  line-height: 90px;
  border-radius: 45px;
  text-align: center;
  background: #236DFF;
  font-size: 34px;
  color: #FFFFFF;
  margin: 30px;
  &.gray {
    opacity: 0.5;
  }
}
.blue {
  color: #236DFF;
}
</style>